import { useState } from "react";
import { MapPin, Images, Trophy } from "lucide-react";
import { useContent } from "../context/SiteContext";
import { mediaUrl } from "../lib/api";
import { Container, PageHero, Empty, Loading } from "../components/site/Common";
import { Lightbox } from "../components/site/Lightbox";

export default function Achievements() {
  const { items } = useContent("achievements");
  const [lb, setLb] = useState({ items: [], index: null });
  return (
    <>
      <PageHero eyebrow="Achievements" title="Milestones & achievements" text="Association milestones, tournaments, player and coaching achievements — in chronological order." />
      <section className="py-16 bg-slate-50 min-h-[50vh]">
        <Container className="max-w-4xl">
          {!items ? <Loading /> : items.length === 0 ? <Empty>No achievements yet.</Empty> : (
            <ol className="relative border-l-2 border-blue-200 ml-4 space-y-10" data-testid="achievements-timeline">
              {items.map((a) => (
                <li key={a.id} className="pl-10 relative reveal" data-testid={`timeline-item-${a.id}`}>
                  <span className="absolute -left-[17px] top-1 h-8 w-8 rounded-full bg-white ring-4 ring-blue-100 grid place-items-center text-amber-500"><Trophy className="h-4 w-4" /></span>
                  <div className="card p-7">
                    <div className="flex flex-wrap items-center gap-3">
                      <span className="font-display text-2xl font-bold text-blue-700">{a.year}</span>
                      <span className="rounded-full bg-slate-100 px-2.5 py-0.5 text-xs font-semibold text-slate-600">{a.category}</span>
                    </div>
                    <h3 className="mt-2 font-display text-xl font-semibold text-[#0B1F44]">{a.title}</h3>
                    <p className="mt-2 text-slate-600 whitespace-pre-line">{a.description}</p>
                    {a.tournament_details && <p className="mt-3 text-sm text-slate-600 bg-slate-50 rounded-xl p-4 whitespace-pre-line">{a.tournament_details}</p>}
                    {a.venue && <p className="mt-3 text-sm text-slate-500 flex gap-2"><MapPin className="h-4 w-4 mt-0.5" />{a.venue}</p>}
                    {a.photos?.length > 0 && (
                      <div className="mt-5 flex items-center gap-3">
                        <div className="flex -space-x-3">{a.photos.slice(0, 3).map((p, i) => <img key={i} src={mediaUrl(p)} alt="" className="h-12 w-12 rounded-xl object-cover ring-2 ring-white" />)}</div>
                        <button onClick={() => setLb({ items: a.photos.map((u) => ({ url: u, media_type: "photo", title: a.title })), index: 0 })} className="btn-outline text-sm" data-testid={`timeline-view-photos-${a.id}`}><Images className="h-4 w-4" /> View photos</button>
                      </div>
                    )}
                  </div>
                </li>
              ))}
            </ol>
          )}
        </Container>
      </section>
      <Lightbox items={lb.items} index={lb.index} onClose={() => setLb({ items: [], index: null })} onIndex={(i) => setLb((x) => ({ ...x, index: i }))} />
    </>
  );
}
